export const SystemActions={
    SAVE_DIMENSIONS:"SAVE_DIMENSIONS",
    OPEN_FEEDBACK_DRAWER:"OPEN_FEEDBACK_DRAWER"
}